// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__181c_","messages":"Chat_messages__2FvxE","dateDivider":"Chat_dateDivider__3N9di"};